module.exports = __webpack_public_path__ + "static/media/arrow-down.a0daf644.svg";